import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppAuthModule } from '@gestor-web/@core/modules';
import { BlendusPreset } from '@gestor-web/app/shared/theme/blendus-preset';
import { AppStoreModule } from '@gestor-web/@core/store/store.module';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutModule } from './layout';
import { PublicModule } from './pages/public';
import { LoaderInterceptorService } from './shared/services';

import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';

import { AgChartsCommunityModule } from 'ag-charts-community';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { AllEnterpriseModule, ModuleRegistry } from 'ag-grid-enterprise';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CookieService } from 'ngx-cookie-service';

const LoaderInterceptor = { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptorService, multi: true };

registerLocaleData(pt);

// Do ag-grid 33 em diante o registro e explicito; AgChartsCommunityModule e exigido pelo enableCharts.
ModuleRegistry.registerModules([AllEnterpriseModule.with(AgChartsCommunityModule)]);

// `theme: 'legacy'` mantem o ag-theme-balham via CSS, em vez da Theming API que o ag-grid 33 tornou padrao.
provideGlobalGridOptions({ theme: 'legacy' });

@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        LayoutModule,
        PublicModule,
        AppRoutingModule,
        AppStoreModule,
        AppAuthModule,
        ConfirmDialogModule], providers: [
        // provido na raiz para que o <p-confirmDialog> unico do AppComponent atenda
        // tambem as telas carregadas por modulos lazy
        ConfirmationService,
        MessageService,
        CookieService,
        LoaderInterceptor,
        {
            provide: LOCALE_ID,
            useValue: 'pt-BR',
        },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
        provideHttpClient(withInterceptorsFromDi(), withInterceptors([includeBearerTokenInterceptor])),
        providePrimeNG({ theme: { preset: BlendusPreset, options: { darkModeSelector: false } } }),
    ] })
export class AppModule {}
